// AccordionItem.tsx
import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { cn } from "@/utils/cn";

export const AccordionItem = (
    props: React.ComponentProps<typeof AccordionPrimitive.Item>
) => {
    const { className, ...rest } = props;
    return (
        <AccordionPrimitive.Item
            data-slot="accordion-item"
            className={cn("border-b last:border-b-0", className)}
            {...rest}
        />
    );
};
AccordionItem.displayName = "AccordionItem";